<template>
  <div>
    <Loader v-if="userWatchlist.length == 0" />
    <div class="dashboard__container--body" v-if="userWatchlist.length > 0">
      <vue-good-table
        :columns="columns"
        :rows="userWatchlist"
        styleClass="vgt-table striped"
        :search-options="{
          enabled: true,
          placeholder: 'Search this table',
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 25,
        }"
        >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'link'">
              <router-link :to="`/users/` + props.row.id" target="_blank">
                <i class="fas fa-external-link ml-3 mr-3"></i>
              </router-link>
            </span>
            <span v-else-if="props.column.field == 'created'">
              <span v-if="props.row.created">{{formatDate(props.row.created)}}</span>
            </span>
          <span v-else-if="props.column.field == 'points'">
            <span v-if="props.row.points" style="display:inline;" class="ml-2 mr-2 success">
              {{props.row.points}}
            </span>
          </span>
          <span v-else-if="props.column.field == 'rating'">
            <span v-if="props.row.rating" style="display:inline;" class="ml-2 mr-2 warning">
              {{props.row.rating}}
            </span>
          </span>
          <span v-else-if="props.column.field == 'blacklist'">
            <span v-if="props.row.blacklist && props.row.blacklist.length >=1" style="display:inline;">
              <v-popover>
                <i class="fas fa-exclamation-triangle ml-2 mr-2" style="color:red;"></i>
                <template slot="popover">
                <span v-for="z in props.row.blacklist">{{z.title}}</span>
              </template>
              </v-popover>
            </span>
          </span>
          <span v-else-if="props.column.field == 'skills'">
            <span v-if="props.row.skills && props.row.skills.length > 0" style="display:inline;">
            <v-popover>
                <i class="fad fa-briefcase ml-2 mr-2"></i>
                <template slot="popover">
                <span v-for="z in props.row.skills">{{z.title}} / </span>
              </template>
              </v-popover>
            </span>
          </span>
          <span v-else-if="props.column.field == 'watchlist'">
           <button v-if="isWatchList(props.row)" class="btn btn__icon" @click="removeWatch(props.row)"><i class="fa-solid fa-star warning"></i></button>
        </span>
          <!-- <span v-else-if="props.column.field == 'addtogroup'">
            <v-select :reduce="group => group.title" :options="groups" label="title" taggable multiple push-tags v-model="props.row.groups" @input="updateUser(props.row)" />
          </span> -->
          <span v-else-if="props.column.field == 'vax'">
            <span v-if="props.row.fullyVaccinated && props.row.fullyVaccinated == `yes`" style="display:inline;">
              <i class="fas fa-syringe ml-2 mr-2" style="color: green;"></i>
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>  
  </div>
</template>

<script>
import * as moment from 'moment'
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
// import ExportService from "@/services/ExportService"
import router from '@/router'

export default {
  name: 'userWatchlist',
  data() {
    return {
      columns: [
        {
          label: 'Link',
          field: 'link',
        },
        {
          label: 'Watchlist',
          field: 'watchlist',
          tdClass: 'text-center-all',
          width: '80px'
        },

        {
          label: 'First',
          field: 'firstName',
        },
        {
          label: 'Last',
          field: 'lastName',
        },
        {
          label: 'Phone',
          field: 'phone',
        },
        {
          label: 'Email',
          field: 'email',
        },
        // {
        //   label: 'Groups',
        //   field: 'addtogroup',
        //   width: '200px'
        // },
        {
          label: 'Points',
          field: 'points',
        },
        {
          label: 'Stars',
          field: 'rating',
        },
        {
          label: 'Skills',
          field: 'skills',
        },
        {
          label: 'City',
          field: 'address.city',
        },
        {
          label: 'State',
          field: 'address.state',
        },
      ]
    };
  },
  computed: {
    ...mapState(['currentUser', 'userProfile', 'userWatchlist']),
  },
  components: {
    Loader,
  },
  created () {
    if (!this.userWatchlist || this.userWatchlist.length < 1) {
      this.$store.dispatch("getUserWatchlist")
    }
  },
  methods: {
    isWatchList(row) {
      if (this.userProfile && this.userProfile.userWatchList && this.userProfile.userWatchList.includes(row.id)) {
        return true
      } else {
        return false
      }
    },
    async removeWatch(row) {
      row.isWatchList = false
      await this.$store.dispatch('unWatchUser', row.id)
    },
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMMM Do YYYY')
      } else {
        return null
      }
    },
  },
}
</script>